<template>
  <div class="home">
    <!-- <div class="bg"></div> -->
    <div class="bg"></div>
    <!-- <img src="../../../static/assets/bg.png" alt class="bg" /> -->
    <section class="content">
      <!-- logo -->
      <div class="logo">
        <img src="../../../static/assets/dzlogo.png" alt />
        <div class="line"></div>
        <div class="title">
          <p class="ch_title">校长信箱</p>
          <span class="en_title">The principal mailbox</span>
        </div>
      </div>
      <!-- 卡片内容 -->
      <div class="back">
        <div class="wrap">
          <email></email>
          <div class="wrapper">
            <div class="wrapper-left">
              <news></news>
            </div>
            <div class="wrapper-right">
              <!-- <total></total> -->
              <!-- <navs></navs> -->
              <tel></tel>
            </div>
          </div>
        </div>
        <div class="bottom">版权信息：© 2016 中南民族大学</div>
      </div>
    </section>
  </div>
</template>
<script>
import email from "../../components/email.vue";
import news from "../../components/news.vue";
import Total from "../../components/total.vue";
import navs from "../../components/nav.vue";
import tel from "../../components/tel.vue";
export default {
  data() {
    return {};
  },
  components: {
    email,
    news,
    Total,
    navs,
    tel
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}

.bg {
  position: absolute;
  left: 0;
  top: 0;
  /* background: url(../../../static/assets/bg.png) no-repeat;
  background-size: 100% 100%;
  width: 120rem; */
  background: #395eaa;
  height: 25rem;
  min-width: 75rem;
  z-index: -1;
  width: 100%;
}

.content {
  width: 75rem;
  margin: 0 auto;
}

.back {
  background: #ffffff;
  border-radius: 0.25rem;
}

.logo {
  display: flex;
  align-items: center;
  margin-top: 1.88rem;
  /* width: 27.13rem; */
  height: 4.13rem;
  /* background: url(../../../static/assets/dzlogo.png) no-repeat; */
  /* background-size: 100% 100%; */
}

.logo img {
  /* border-right: 0.025rem solid #fff; */
}

.logo .line {
  width: 0.025rem;
  height: 2rem;
  background: #fff;
}

.logo .title {
  padding-left: 1.5rem;
  text-align: center;
}

.logo p {
  font-size: 1.5rem;
  color: #fff;
  /* padding-left: 1rem; */
}

.wrap {
  width: calc(100% - 2.64rem);
  padding: 1.25rem 1.32rem 0;
  margin-top: 1.75rem;
}

.wrapper {
  display: flex;
}

.wrapper-left {
  width: 35.63rem;
}

.wrapper-right {
  width: 35.63rem;
  height: 35.75rem;
  margin-left: 1.31rem;
}

.bottom {
  width: 100%;
  height: 2rem;
  background: #395eaa;
  margin-top: 1.44rem;
  text-align: center;
  line-height: 2rem;
  color: #fff;
  font-size: 0.75rem;
}

.en_title {
  font-size: 0.75rem;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// index.vue?c34f12aa